// hooks/useDeviceDetect.ts
import { useState, useEffect } from "react";

interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isIOS: boolean;
  isAndroid: boolean;
}

export function useDeviceDetect(): DeviceInfo {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>(() => getDeviceInfo());

  useEffect(() => {
    setDeviceInfo(getDeviceInfo());
    // const handleResize = () => setDeviceInfo(getDeviceInfo());
    // window.addEventListener("resize", handleResize);
    // return () => window.removeEventListener("resize", handleResize);
  }, []);

  return deviceInfo;
}

function getDeviceInfo(): DeviceInfo {
  const ua = navigator.userAgent;

  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);

  // User agent check
  const isMobileUA = /iPhone|Android.*Mobile|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTabletUA = /iPad|Android(?!.*Mobile)/i.test(ua);

  // Screen width check as fallback
  const isMobileScreen = window.innerWidth < 768;
  const isTabletScreen = window.innerWidth >= 768 && window.innerWidth < 1024;

  const isMobile = isMobileUA;
  const isTablet = isTabletUA;

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    isIOS,
    isAndroid,
  };
}
